import activeModules from '@/pmgc/activeModules'
import ErrPage from '@/components/layouts/404'
import Index from './index'
import About from './about'
import Bootcamp from './bootcamp'
import ContactUs from './contact'
import Payment from '@/components/testingPaystack'
import Paystack from '@/components/paystack'
import Pay from '@/components/vogue'
// import CBT from '@/pmgc/access/cbt'
// import PhotoTest from '@/components/testUpload'

let routes = [
  {
    path: '/',
    name: 'Platinum Minds Global Company',
    component: Index
  },
  {
    path: '/payment',
    name: 'PMGC Payment Platform',
    component: Payment
  },
  {
    path: '/payments',
    name: 'PMGC Payment Platform',
    component: Paystack
  },
  {
    path: '/vogue',
    name: 'TEST PMGC',
    component: Pay
  },
  {
    path: '/about',
    name: 'About Platinum Minds Global Company',
    component: About
  },
  {
    path: '/contact',
    name: 'PMGC || Contact us',
    component: ContactUs
  },
  {
    path: '/bootcamp',
    name: 'PMGC Coding Bootcamp 2022',
    component: Bootcamp
  },
  // {
  //   path: '/photo',
  //   name: 'Testing upload',
  //   component: PhotoTest
  // },
  // {

  //   path: '/registration',
  //   name: 'Register for PRC 2018',
  //   component: Register
  // },
  {
    path: '*',
    name: 'Error 404',
    component: ErrPage
  }
]

activeModules.forEach(modul => {
  try {
    // get module routes
    let moduleRoutes = require('@/pmgc/' + modul + '/router').default
    // add the routes gotten to the route array
    routes = routes.concat(moduleRoutes)
    // console.log(routes)
  } catch (e) {
    console.log(e)
  }
})

export default routes



// WEBPACK FOOTER //
// ./src/pmgc/router.js